export default "__VITE_ASSET__JtfAdvxG__"